import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Create a new context
export const MyContext = createContext();

const MyProvider = ({ children }) => {
  const localURL = localStorage.getItem("shopURL");
  const location = useLocation(); // To track the current route
  const activePath = location.pathname;

  const headers = {
    "Content-Type": "application/json",
    "x-shop-url": localURL,
  };

  const [userLimit, setUserLimit] = useState(true);
  const [removeBranding, setRemoveBranding] = useState(true);
  const [removeBrandingChecked, setRemoveBrandingChecked] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);

  const [activeItem, setActiveItem] = useState("dashboard"); // Initial active item

  // Settings
  const options = [
    {
      label: "Gradient 1",
      gradient: "linear-gradient(to bottom right, #2A27DA, #00CCFF)",
    },
    {
      label: "Gradient 2",
      gradient: "linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)",
    },
    {
      label: "Gradient 3",
      gradient: "linear-gradient(120deg, #f6d365 0%, #fda085 100%)",
    },
    {
      label: "Gradient 4",
      gradient: "linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)",
    },
    {
      label: "Gradient 5",
      gradient: "linear-gradient(120deg, #a6c0fe 0%, #f68084 100%)",
    },
    {
      label: "Gradient 6",
      gradient: "linear-gradient(to right, #4facfe 0%, #00f2fe 100%)",
    },
    {
      label: "Gradient 7",
      gradient: "linear-gradient(to right, #43e97b 0%, #38f9d7 100%)",
    },
    {
      label: "Gradient 8",
      gradient: "linear-gradient(to top, #30cfd0 0%, #330867 100%)",
    },
    {
      label: "Gradient 9",
      gradient: "linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)",
    },
  ];

  const [position, setPosition] = useState("left");
  const [iconText, setIconText] = useState("Chat with Us 👋");
  const [selectedColor, setSelectedColor] = useState(options[0].gradient);
  const [firstChat, setFirstChat] = useState("Hi,How can i assist you today?");
  const [botFirstChat, setBotFirstChat] = useState(
    "Hi,I'm a AI Bot Ask me what you are looking for.?"
  );

  // Display Rule States
  const [checkboxes, setCheckboxes] = useState({
    showOnTimer: true,
    showAfterScrolling: false,
    showOnExitIntent: false,
    showOnHtmlElementClick: false,
  });
  const [timerOption, setTimerOption] = useState("");
  const [scrollOption, setScrollOption] = useState("");
  const [element, setElement] = useState("");
  const [deviceSelection, setDeviceSelection] = useState("allDevices");
  const [pageSelection, setPageSelection] = useState("allPages");
  const [selectedPages, setSelectedPages] = useState([]);
  const [cartValueSelection, setCartValueSelection] = useState("anyCartValue");
  const [specificCartValue, setSpecificCartValue] = useState("");
  const [numInputBoxes, setNumInputBoxes] = useState(1);
  const [amounts, setAmounts] = useState([""]);
  const [countrySelection, setCountrySelection] = useState("allCountries");
  const [selectedCountries, setSelectedCountries] = useState([]);

  const fetchExcistingData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/appearence-rules`,
        { headers }
      );
      // console.log(response);
      const settingData = response.data.settingData;
      const displayRule = response.data.displayRule;
      if (displayRule) {
        setCheckboxes(displayRule.checkboxes);
        setTimerOption(displayRule.timerOption);
        setScrollOption(displayRule.scrollOption);
        setElement(displayRule.element);
        setDeviceSelection(displayRule.deviceSelection);
        setPageSelection(displayRule.pageSelection);
        setSelectedPages(displayRule.selectedPages);
        setCartValueSelection(displayRule.cartValueSelection);
        setSpecificCartValue(displayRule.specificCartValue);
        setNumInputBoxes(displayRule.numInputBoxes || 1);
        setAmounts(displayRule.amounts);
        setCountrySelection(displayRule.countrySelection);
        setSelectedCountries(displayRule.selectedCountries);
      }
      if (settingData) {
        setPosition(settingData.Icon.IconPosition);
        setIconText(settingData.iconText);
        setSelectedColor(settingData.iconColor);
        setFirstChat(settingData.firstChat);
        setBotFirstChat(settingData.botFirstChat);
        setRemoveBrandingChecked(settingData.removeBrandingChecked)
      }
    } catch (err) {
      console.log("Error getting the Settings Data:", err);
    }
  };

  useEffect(() => {
    if (activePath.includes("/chat/")) {
      fetchExcistingData();
    }
  }, []);

  return (
    <MyContext.Provider
      value={{
        removeBranding,
        setRemoveBranding,
        removeBrandingChecked,
        setRemoveBrandingChecked,
        userLimit,
        setUserLimit,
        selectedColor,
        isSidebarMinimized,
        setIsSidebarMinimized,
        setSelectedColor,
        firstChat,
        setFirstChat,
        botFirstChat,
        setBotFirstChat,
        activeItem,
        setActiveItem,
        isSidebarOpen,
        setIsSidebarOpen,
        position,
        setPosition,
        iconText,
        setIconText,

        checkboxes,
        setCheckboxes,
        timerOption,
        setTimerOption,
        scrollOption,
        setScrollOption,
        element,
        setElement,
        deviceSelection,
        setDeviceSelection,
        pageSelection,
        setPageSelection,
        selectedPages,
        setSelectedPages,
        cartValueSelection,
        setCartValueSelection,
        specificCartValue,
        setSpecificCartValue,
        numInputBoxes,
        setNumInputBoxes,
        amounts,
        setAmounts,
        countrySelection,
        setCountrySelection,
        selectedCountries,
        setSelectedCountries,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyProvider;
